import React, { useState, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import {Card, CardContent, Grid, Typography, Button, Box, Chip, Stack, Tooltip} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from "@mui/icons-material/Person";
import WorkIcon from "@mui/icons-material/Work";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateBookingPrice } from '../../redux/actions/bookingActions'; // Import the booking action
import dayjs from 'dayjs';
import Collapse from '@mui/material/Collapse';
import { useMediaQuery } from '@mui/material';
import { pushChangeCurrency } from '../../gtm';

import { setCreateBookingResponse } from '../../redux/actions/createBookingActions';
import { pushQuoteBook } from '../../gtm';
import TrustpilotImage from './images/travelOptions/trustpilot.jpeg';


// SVG IMPORTS 
import BUS from './images/travelOptions/BUS.png';
import COAC from './images/travelOptions/COAC.png';
import DSHU from './images/travelOptions/DSHU.png';
import EC from './images/travelOptions/EC1.png';
import ECON from './images/travelOptions/ECON.png';
import EIGHTLIM from './images/travelOptions/EIGHTLIM.png';
import EXEC from './images/travelOptions/EXEC.png';
import HELI from './images/travelOptions/HELI.png';
import LIMO from './images/travelOptions/LIMO.png';
import LSUV from './images/travelOptions/LSUV.png';
import PRIO from './images/travelOptions/PRIO.png';
import PRIV from './images/travelOptions/PRIV.png';
import SCHD from './images/travelOptions/SCHD.png';
import SHAR from './images/travelOptions/SHAR.png';
import SHPL from './images/travelOptions/SHPL.png';
import ECLX from './images/travelOptions/ECLX.png';
import ECOP from './images/travelOptions/ECOP.png';
import ECPR from './images/travelOptions/ECPR.png';

import { setCombinations } from '../../redux/actions/mixedProductActions';
import { GTMTrigger } from './GTMtrigger';
import ProgressBar from '../ProgressBar/ProgressBar';
import {setQuoteResponse} from "../../redux/actions";
import PromoCodeInput from "../PromoCodeInput";


const styles = (theme) => ({
  centerAlignXs: {
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  root: {
    flexGrow: 1,
    backgroundColor: '#FCFDFD',
  },
  title: {
    textAlign: 'center',
    color: '#444',
    font: '18px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    fontWeight: 'bold',
  },
  title2: {
    textAlign: 'center',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#333',
    fontFamily: 'Nexa,sans-serif',
    lineHeight: '1.1',
  },
  title3: {
    fontSize: '24px',
    fontFamily: 'Nexa,sans-serif',
    color: '#265886',
    lineHeight: '1.5',
    fontWeight: '700',
  },
  subtitle: {
    textAlign: 'left',
    font: '14px arial,serif',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    marginTop: '10px',
  },
  subtitle1: {
    textAlign: 'center',
    fontSize: '1em',
    fontFamily: 'Nexa,sans-serif',
    color: '#444',
    fontWeight: '700',
  },
  info: {
    fontSize: '12px',
    color: '#444',
    fontFamily: 'Nexa,sans-serif',
    cursor: 'pointer',
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
    textTransform: 'none',
  },
  button1: {
    backgroundColor: 'rgb(17, 137, 17)',
    color: 'rgb(255, 255, 255)',
    width: '150px',
    height: '40px',
    borderRadius: '6px',
    textTransform: 'none',
    marginTop: '4px',
    padding: '0px 50px',
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minWidth: '183px',
    minHeight: '50px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  spacing: {
    marginTop: '6px',
  },
  underline: {
    position: 'relative',
    display: 'inline-block',
  },
  underlineBefore: {
    position: 'absolute',
    content: '""',
    left: 0,
    right: 0,
    bottom: -1,
    height: '4px',
    backgroundColor: '#138911',
    borderRadius: '5px',
  },
  selectContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  select: {
    textAlign: 'center',
    backgroundColor: '#138911',
    color: 'white',
    '& .MuiSelect-icon': {
      color: 'white',
    },
  },
  icon: {
    width: '200px', // Adjust to 100
    height: '150px', // Adjust to 200
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', // Ensures the icon stays centered
  },

  iconSvg: {
    width: '100%',
    height: '100%',
  },

  dialog: {
    backgroundColor: '#ededed',
    padding: '20px 20px 10px',
    color: '#265886',
    minWidth: '400px',
  },
  dialogFont: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '14px',
    fontWeight: '500',
  },
  closeIcon: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    cursor: 'pointer',
    color: '#999',
  },
  noWait: {
    fontFamily: '"Nexa","Arial",sans-serif!important',
    fontSize: '17px',
    fontWeight: '500',
    color: '#265886',
  },
});



function stripHtmlTags(htmlString) {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlString;
  return tempDiv.textContent || tempDiv.innerText || "";
}

const QuoteProducts = ({ classes, theme }) => {


  const [schdMessage, setSchdMessage] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('');
  const [loadingIndex, setLoadingIndex] = useState(null);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiFrontendURL = process.env.REACT_APP_FRONT_END_URL;


  const dispatch = useDispatch(); // Initialize useDispatch hook


  const quoteResponse = useSelector(state => state.quoteResponse);
  const travelDetails = useSelector(state => state.travelDetails);
  const createBookingResponse = useSelector(state => state.createBooking);
  const combinations = useSelector((state) => state.mixedProduct.combinations); // Replace 'yourReducerName' with the actual name of the reducer holding the combinations.
  const promoCode = useSelector(state => state.promoCode?.promoCode ?? '');
  const promoCodeInputDisplay = useSelector(state => state.systemSettings?.promoCodeInputDisplay ?? true);

  const { book } = useSelector((state) => state.booking);

  const [selectedCurrency, setSelectedCurrency] = useState('GBP');

  useEffect(() => {
    setSelectedCurrency(quoteResponse.basket.currency[0]);
  }, [quoteResponse]);

  // Handle currency change event
  const handleCurrencyChange = async (event) => {

    // Fetch exchange rates for the newly selected currency
    const newCurrency = event.target.value;

    // Gather change currency details for GTM
    const changeCurrencyDetails = {
      'DLV - currency': newCurrency,
    };

    // Push the change quote details to the data layer
    pushChangeCurrency(changeCurrencyDetails);

    const headers = {
      'Content-Type': 'application/json'
    };

    const newBody = {
      "basket": {
        "id": quoteResponse.basket.id,
        "currency": {
          "code": newCurrency
        },
        "promoCode": promoCode
      }
    };

    //TODO:: IF THIS DOESNT WORK THE JUST CALL FIND ENDPOINT

    fetch(`${apiBaseUrl}/basket/updateBasket`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(newBody)
    })
        .then(response => response.json())
        .then(data => {
          dispatch(setQuoteResponse(data));
          setSelectedCurrency(newCurrency);
        })
        .catch(error => {
          //console.log(error);
        });
  };

  const currencySymbols = {
    GBP: '£', // Great British Pound
    USD: '$', // US Dollar
    EUR: '€', // Euro
    CAD: 'C$', // Canadian Dollar
    CHF: 'CHF', // Swiss Franc
    NOK: 'kr', // Norwegian Krone
    SEK: 'kr', // Swedish Krona
    AED: 'AED', // UAE Dirham
    DKK: 'kr', // Danish Krone
    AUD: 'AUD$', // Australian Dollars
  };

  // Initialize an array of state variables, one for each quote
  const [isMoreInfoOpenArray1, setMoreInfoOpenArray1] = useState(
    new Array(combinations.length).fill(false)
  );

  // Function to toggle the "More Info" section for a specific quote
  const toggleMoreInfo1 = (index) => {
    const updatedArray = [...isMoreInfoOpenArray1];
    updatedArray[index] = !updatedArray[index];
    setMoreInfoOpenArray1(updatedArray);
  };


  const shouldHideCombinations = (options, combinations) => {
    // Existing checks
    const isPrivateBookedInOptions = options.some(option =>
      option.transferTypeCode === "PRIV" && option.book
    );

    const isSharedBookedInOptions = options.some(option =>
      option.transferTypeCode === "SHAR" && option.book
    );

    const isPrivateInCombinationsBooked = combinations.length > 0 &&
      combinations[0].outbound &&
      combinations[0].outbound.transferTypeCode === "PRIV" &&
      combinations[0].outbound.book;

    const isSharedInCombinationsBooked = combinations.length > 0 &&
      combinations[0].outbound &&
      combinations[0].outbound.transferTypeCode === "SHAR" &&
      combinations[0].outbound.book;

    const isPrivateUnavailable = !options.some(option =>
      option.transferTypeCode === "PRIV"
    );

    const isSharedUnavailable = !options.some(option =>
      option.transferTypeCode === "SHAR"
    );

    // New condition to check if a mixed product of PRIV/SHAR or SHAR/PRIV exists in combinations
    const isMixedPrivateSharedAvailable = combinations.some(combination =>
      combination.outbound && combination.inbound &&
      (
        (combination.outbound.transferTypeCode === "PRIV" && combination.inbound.transferTypeCode === "SHAR") ||
        (combination.outbound.transferTypeCode === "SHAR" && combination.inbound.transferTypeCode === "PRIV")
      )
    );

    // Check if "Shared outbound and Private inbound" should be shown
    const showSharedOutboundPrivateInbound = combinations.some(combination =>
      combination.outbound.transferTypeCode === "SHAR" &&
      combination.inbound.transferTypeCode === "PRIV" &&
      isSharedBookedInOptions && !isPrivateBookedInOptions
    );

    // Check if "Private outbound and Shared inbound" should be shown
    const showPrivateOutboundSharedInbound = combinations.some(combination =>
      combination.outbound.transferTypeCode === "PRIV" &&
      combination.inbound.transferTypeCode === "SHAR" &&
      isPrivateBookedInOptions && !isSharedBookedInOptions
    );

    // Combine the logic for mixed combinations and specific shared/private combinations
    const showMixedCombination = (
      (isPrivateUnavailable || isSharedUnavailable) && isMixedPrivateSharedAvailable
    );



    const showSpecificCombination = showSharedOutboundPrivateInbound || showPrivateOutboundSharedInbound;

    // Determine if combinations should be hidden based on the conditions
    const hide = (
      (isPrivateBookedInOptions && isPrivateInCombinationsBooked) ||
      (isSharedBookedInOptions && isSharedInCombinationsBooked) ||
      (isSharedBookedInOptions && isPrivateUnavailable) ||
      (isPrivateBookedInOptions && isSharedUnavailable)
    );

    // If the mixed combination or specific combination should be shown, override the hide logic to show it
    return showSpecificCombination || showMixedCombination ? false : hide;
  };

  const hideCombinations = shouldHideCombinations(quoteResponse.basket.options, combinations);
  // console.log('Hide combinations result:', hideCombinations);
  // console.log("check hide combinations", hideCombinations)

  // New logic for // Combining both combinations and quoteResponse.basket.options
  const combinedArray = hideCombinations
    ? [...quoteResponse.basket.options.map((item) => ({
      transferTypeCode: item.transferTypeCode,  // Regular quoteResponse structure
      book: item.book,
      totalCost: item.optionCost.totalCost,
      costPerPerson: item.optionCost.costPerPerson,
      description: item.description,  // Keep description if needed
      isCombination: false  // Add a flag to indicate it’s not a combination
    }))]  // Only use options if hideCombinations is true
    : [
      ...combinations.map((item) => ({
        transferTypeCode: `${item.outbound.transferTypeCode} / ${item.inbound.transferTypeCode}`,  // For combinations, merge outbound/inbound codes
        book: item.outbound.book && item.inbound.book,  // Both outbound and inbound must be bookable
        totalCost: item.totalCost,
        costPerPerson: item.costPerPerson,
        outbound: item.outbound,  // Keep outbound and inbound details
        inbound: item.inbound,
        isCombination: true  // Add a flag to differentiate combinations
      })),
      ...quoteResponse.basket.options.map((item) => ({
        transferTypeCode: item.transferTypeCode,  // Regular quoteResponse structure
        book: item.book,
        totalCost: item.optionCost.totalCost,
        costPerPerson: item.optionCost.costPerPerson,
        description: item.description,  // Keep description if needed
        isCombination: false  // Add a flag to indicate it’s not a combination
      }))
    ];

  // Sorting the combined array based on totalCost and book status
  const sortedCombinedArray = combinedArray
    .filter(option => {
      if (option.isCombination === false) {
        return true
      } else {
        return !option.transferTypeCode.includes("SCHD")
      }
    })  // Filter SCHD with book: false
    .sort((a, b) => {
      if (a.book === b.book) {
        return a.totalCost - b.totalCost;
      } else {
        return a.book ? -1 : 1;
      }
    });
  // console.log("Sorted Combined Array", sortedCombinedArray)



  const navigate = useNavigate();

  useEffect(() => {
    if (loading) {
      setLoadingText(book === false ? 'Booking Processing' : 'Booking Processing');

      return () => {
        // Cleanup logic, if any
      };
    }
  }, [loading, book]);


  // Initialize transfers array with the first transfer
  let transfers;

  const handleBookNow = async (index, totalCost, costPerPerson, transfer_type, short_description, selectedCurrency, transfer_type1 = undefined) => {

    // Set loading state for the specific button
    setLoadingIndex(index);
    setLoading(true);
    // Gather book  details for GTM
    // const quoteBookDetails = {
    //   'DLV - typeOfTransfer': transfer_type,
    //   'DLV - transactionTotal': totalCost
    // };

    // Push the book  details to the data layer
    // pushQuoteBook(quoteBookDetails);
    const headers = {
      'Content-Type': 'application/json'
    };

    if (transfer_type1 !== undefined) {
      // console.log("check", transfer_type)
      // console.log("check2", transfer_type1)
      // UPDATE BASKET for combinations
      // Construct the first transfer object
      const firstTransfer = {
        "id": createBookingResponse.basket.transfers[0].id,
        "transferType": {
          "code": transfer_type,
          "description": short_description,
          "descriptionShort": "",
          "descriptionLong": "",
          "totalCost": 0,
          "costPerPerson": 0
        }
      };

      transfers = [firstTransfer];

      // Conditionally add the second transfer if it exists
      if (createBookingResponse.basket.transfers[1]) {
        const secondTransfer = {
          "id": createBookingResponse.basket.transfers[1].id,
          "transferType": {
            "code": transfer_type1,
            "description": short_description,
            "descriptionShort": "",
            "descriptionLong": "",
            "totalCost": 0,
            "costPerPerson": 0
          }
        };
        transfers.push(secondTransfer);
      }
    } else {
      // Construct the first transfer object
      const firstTransfer = {
        "id": createBookingResponse.basket.transfers[0].id,
        "transferType": {
          "code": transfer_type,
          "description": short_description,
          "descriptionShort": "",
          "descriptionLong": "",
          "totalCost": 0,
          "costPerPerson": 0
        }
      };

      // Initialize transfers array with the first transfer
      transfers = [firstTransfer];

      // Conditionally add the second transfer if it exists
      if (createBookingResponse.basket.transfers[1]) {
        const secondTransfer = {
          "id": createBookingResponse.basket.transfers[1].id,
          "transferType": {
            "code": transfer_type,
            "description": short_description,
            "descriptionShort": "",
            "descriptionLong": "",
            "totalCost": 0,
            "costPerPerson": 0
          }
        };
        transfers.push(secondTransfer);
      }
    }

    // Construct the newBody with the dynamically created transfers array
    const newBody = {
      "basket": {
        "id": quoteResponse.basket.id,
        "currency": {
          "code": selectedCurrency
        },
        "transfers": transfers
      }
    };

    // console.log("check3", newBody)


    await fetch(`${apiBaseUrl}/basket/updateBasket`, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(newBody)
    })
      .then(response => {
        if (response.status === 500) {
          setLoading(false)
          // If the response status code is 500, handle it accordingly
          throw new Error('500 - Server Error');
        }
        return response.json();
      })
      .then(async (data) => {

        dispatch(setCreateBookingResponse(data));
        // GET BASKET 
        return await fetch(`${apiBaseUrl}/basket/getBasket?guid=${quoteResponse.basket.guid}`, {
          method: 'GET',
          headers: headers,
        });
      })
      .then((response) => response.json())
      .then((data) => {

        // Book Logic
        // Find the object with transferTypeCode "PRIV" in the options array
        const transferTypeOption = data.basket.options.find(option => option.transferTypeCode === transfer_type);

        // Check if the privOption object exists and has a "book" property
        if (transferTypeOption && transferTypeOption.hasOwnProperty('book')) {
          // Access the value of the "book" property
          const bookValue = transferTypeOption.book;
          if (bookValue === false) {



            // Gather Booking Successfull Details for GTM
            const getQuoteDetails = {
              currency: quoteResponse.basket.currency[0],
              value: parseFloat((Math.round(totalCost) / 100).toFixed(2)),                     // order total.
              items: [{
                item_name: quoteResponse.basket.transfers[0].fromDestination.name + " to " + quoteResponse.basket.transfers[0].toDestination.name, // Name of the item
                price: parseFloat((Math.round(totalCost) / 100).toFixed(2)),
                item_category: transfer_type,
                item_category2: quoteResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
                quantity: 1 // Quantity of the item
              }]
            }
            // console.log("check quote details1", getQuoteDetails)
            pushQuoteBook(getQuoteDetails)

          }
          else if (bookValue === true) {
            const getQuoteDetails = {
              currency: quoteResponse.basket.currency[0],
              value: parseFloat((Math.round(totalCost) / 100).toFixed(2)),                     // order total.
              items: [{
                item_name: quoteResponse.basket.transfers[0].fromDestination.name + " to " + quoteResponse.basket.transfers[0].toDestination.name, // Name of the item
                price: parseFloat((Math.round(totalCost) / 100).toFixed(2)),
                item_category: transfer_type,
                item_category2: quoteResponse.basket.transfers.length > 1 ? "Return" : "One way", // Category based on number of transfers
                quantity: 1 // Quantity of the item
              }]
            }
            // console.log("check quote details2", getQuoteDetails)
            pushQuoteBook(getQuoteDetails)
          }
          // Dispatch the action to update booking price, transfer_type and book status
          dispatch(updateBookingPrice(totalCost, costPerPerson, transfer_type, bookValue, short_description, selectedCurrency));
          // Now, you can use the "bookValue" in your code as needed

        } else {
          // Handle the case where the "PRIV" option was not found or doesn't have a "book" property
          // console.log("Transfer Type option not found or missing 'book' property");
        }
        setLoadingIndex(null);
        setLoading(false);


        navigate('/booking');


      })
      .catch(error => {

        if (transfer_type === "SCHD") {
          setLoading(false)
          setSchdMessage(true)
        }


        // If the error message includes '500', it's a server error
        if (error.message.includes('500')) {
          setLoading(false)
          // Handle the server error
          // console.error('Server error occurred:', error);
          // Update the UI to indicate buses are not available
          // Here you can dispatch an action to set an error message
          // Example:
          // dispatch(setErrorMessage('Buses are not available for SCHD transfer type'));
        } else {
          // Handle other types of errors
          // console.error('An error occurred:', error);
        }
      });
  };


  // console.log("adults", travelDetails.adultsCount + travelDetails.childrenCount.length)
  // Inside your component
  // const isSmOrXsOrMdScreen = useMediaQuery(theme.breakpoints.down('md'));


  // const isXsOrSmScreen = useMediaQuery(theme.breakpoints.down("sm")); // Only xs, sm
  // const isMdScreen = useMediaQuery(theme.breakpoints.only("md")); // Only md
  // const isLgScreen = useMediaQuery(theme.breakpoints.only("lg")); // Only lg

  const isSmOrXsOrMdScreen2 = useMediaQuery(theme.breakpoints.down("lg")); // Up to lg


  // const TrustpilotReview = () => {
  //   useEffect(() => {
  //     // Load Trustpilot script dynamically
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  //     script.async = true;
  //     document.body.appendChild(script);

  //     return () => {
  //       document.body.removeChild(script);
  //     };
  //   }, []);

  //   return (
  //     <div
  //       className="trustpilot-widget"
  //       data-locale="en-GB"
  //       data-template-id="53aa8807dec7e10d38f59f32"
  //       data-businessunit-id="594a30a40000ff0005a505e6"
  //       data-style-height="150px"
  //       data-style-width="100%"
  //       style={{ marginTop: '8px', textAlign: 'center', pointerEvents: 'none' }}
  //     >
  //       <a
  //         href="https://uk.trustpilot.com/review/www.ski-lifts.com"
  //         target="_blank"
  //         rel="noopener noreferrer"
  //         style={{ pointerEvents: 'none', textDecoration: 'none', color: 'inherit' }}
  //       >
  //         Trustpilot
  //       </a>
  //     </div>
  //   );
  // };

  const getIcon2 = (type) => {
    const iconMap = {
      PRIV,
      BUS,
      COAC,
      DSHU,
      EC,
      ECON,
      EIGHTLIM,
      EXEC,
      HELI,
      LIMO,
      LSUV,
      PRIO,
      SCHD,
      SHAR,
      SHPL,
      ECLX,
      ECOP,
      ECPR,
    };

    const largeIcons = ['DSHU', 'EC', 'ECON', 'ECPR', 'SCHD', 'PRIV', 'SHAR'];

    const getIconSize = (type) => {
      if (type === 'SHAR') {
        return { width: 255, height: 142 };
      } else if (largeIcons.includes(type)) {
        return { width: 210, height: 150 };
      } else {
        return { width: 139, height: 165 };
      }
    };

    const scaleFactor = isSmOrXsOrMdScreen2 ? 0.75 : 1;
    const baseSize = getIconSize(type);

    const iconStyle = {
      width: `${baseSize.width * scaleFactor}px`,
      height: `${baseSize.height * scaleFactor}px`,
    };



    const iconSrc = iconMap[type];
    if (!iconSrc) return null;

    return (
      <div style={{ textAlign: 'center' }}>
        <img src={iconSrc} alt={`${type} icon`} style={iconStyle} />

      </div>
    );
  };
  const getIcon = (type) => {
    const iconMap = {
      PRIV,
      BUS,
      COAC,
      DSHU,
      EC,
      ECON,
      EIGHTLIM,
      EXEC,
      HELI,
      LIMO,
      LSUV,
      PRIO,
      SCHD,
      SHAR,
      SHPL,
      ECLX,
      ECOP,
      ECPR,
    };

    const largeIcons = ['DSHU', 'EC', 'ECON', 'ECPR', 'SCHD', 'PRIV', 'SHAR'];

    const iconStyle = type === 'SHAR'
      ? { width: '265px', height: '152px' } // Custom dimensions for 'SHAR'
      : largeIcons.includes(type)
        ? { width: '220px', height: '160px' }
        : { width: '149px', height: '175px' };


    const iconSrc = iconMap[type];
    if (!iconSrc) return null;

    return (
      <div style={{ textAlign: 'center' }}>
        <img src={iconSrc} alt={`${type} icon`} style={iconStyle} />

      </div>
    );
  };

  const getTransferTypeUSPMain = (type) => {
    switch (type) {
      case 'PRIV':
        return 'No-wait door to door service';
      case 'PRCR':
        return 'No-wait door to door service';
      case 'Acc':
        return 'No-wait door to door service';
      case 'ECOP':
        return 'Travel in an Electric or Hybrid vehicle';
      case 'LIMO':
        return 'Extra comfort in a luxury vehicle';
      case 'EXEC':
        return 'Extra comfort in a luxury minivan';
      case 'ECLX':
        return 'Extra comfort in a luxury electric or hybrid vehicle';
      case 'COAC':
        return 'For larger group travel';
      case 'SHAR':
        return 'Shared transfer, save money';
      case 'SCHD':
        return 'Scheduled Shared Transfer';
      case 'ECON':
        return 'Best value shared transfer!';
      case 'PRIO':
        return 'Door-to-door service, shorter wait time';
      case 'BUS':
        return 'Completely Carbon Neutral Transfer!';
      case 'SHPL':
        return 'Shared transfer, even shorter wait time';
      case 'MEMS':
        return 'This is a Shared service';
      case 'HELI':
        return 'VIP transfer - arrive in style';
      case 'LSUV':
        return 'Extra comfort in a luxury SUV';
      case 'DSHU':
        return 'Shared transfer, Set timetable';
      case 'AOSH':
        return 'Shared transfer, Set timetable';
      case 'EC1':
        return 'Timetabled shared service';
      case 'ECPR':
        return 'Up to 30mins wait at an agreed meeting point';
      case 'M&G':
        return 'Meet & Greet';
      case 'LUN':
        return 'Meet & Greet';
      case 'PTNS':
        return 'No-wait Service'
      case 'LXGL':
        return 'Extra comfort in a luxury minivan';
      case '8HRS':
        return '8 Hour Hire (inc 200 KMs)';
      case 'DVD':
        return 'Private Vehicle & Driver Hire';
      case '12HR':
        return '12 Hour Hire (inc 400 KMs)';
      default:
        return null
    }
  }

  const getTransferUSPs = (type) => {
    switch (type) {
      case 'PRIV':
        return [
            'Meet & Greet',
            '24/7 Support',
            'Family friendly'
        ];
      case 'SCHD':
       return [
            'Budget Friendly',
            '24/7 Support',
        ];
      default:
        return [
            'Meet & Greet',
            '24/7 Support',
        ];
    }
  }

  const getTransferType = (type) => {
    switch (type) {
      case 'PRIV':
        return "Private";
      case 'SHAR':
        return "Shared";
      case 'EXEC':
        return "Luxury Minibus";
      case 'COAC':
        return "Private Coach";
      case 'LIMO':
        return "Luxury Car";
      case 'SCHD':
        return "Scheduled Shuttle";
      case 'ECON':
        return "Economy";
      case 'PRIO':
        return "Priority Shared";
      case 'SHPL':
        return "Shared Plus";
      case 'PRGF':
        return "Private Golf Transfer";
      case 'GLF':
        return "Golf Transfer";
      case 'PCG':
        return "Private Coach Golf";
      case 'HELI':
        return "Helicopter Transfer"
      case 'SHTL':
        return "Shuttle"
      case 'AP2':
        return "Airport Package 2"
      case 'AP3':
        return "Airport Package 3"
      case 'AP4':
        return "Airport Package 4"
      case 'AP5':
        return "Airport Package 5"
      case 'AP6':
        return "Airport Package 6"
      case 'GP2':
        return "Golf Package Two"
      case 'GP3':
        return "Golf Package Three"
      case 'GP4':
        return "Golf Package Four"
      case 'GP6':
        return "Golf Package Six"
      case 'LSUV':
        return "Luxury SUV"
      case 'DSHU':
        return "Denver Shuttle"
      case 'AOSH':
        return "Aosta Shuttle"
      case 'AP1':
        return "Airport Package 1"
      case 'GP1':
        return "Golf Package One"
      case 'EC1':
        return "Economy Shuttle"
      case 'ECPR':
        return "Economy Private"
      case 'ECLX':
        return "Eco Luxury"
      case 'ECOP':
        return "Eco Private"
      case 'REP':
        return "Meet and Greet Rep"
      default:
        return null;
    }
  };

  const holdLuggage = travelDetails.adultsCount + travelDetails.childrenCount.length;

  return (
    <div>
      <div>
        <GTMTrigger />
        <Card sx={{ backgroundColor: '#f1f2f5' }}>
          <CardContent sx={{ backgroundColor: '#f1f2f5' }} >
            <Grid container spacing={2} style={{ flexGrow: 1, backgroundColor: '#f1f2f5', }}>
              <Grid item xs={12} md={12} >
                <Typography variant="h5" style={{
                  textAlign: 'center',
                  color: '#444',
                  font: '18px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  fontWeight: 'bold',
                }}>
                  Your Search
                </Typography>
              </Grid>
              <Grid item xs={12} md={12}>
                <Typography variant="subtitle1" style={{
                  textAlign: 'left',
                  font: '12px arial,serif',
                  fontFamily: 'Nexa,sans-serif',
                  color: '#444',
                  lineHeight: '1.1',
                }}>
                  <span style={{ fontWeight: 'bold' }}>Outbound:</span> {travelDetails.pickupValue.label} To {travelDetails.dropoffValue.label} On The {dayjs(travelDetails.outboundDate).format('D MMM, YYYY')} At
                  <span> {travelDetails.outboundTime} For  </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount > 0 || travelDetails.infantsCount > 0 ? (
                    <span>
                      {travelDetails.adultsCount} Adults
                      {travelDetails.childrenCount.length > 0 &&
                        `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'}`}
                      {`, Hold Luggage ${holdLuggage}`}
                    </span>
                  ) : null}

                </Typography>
              </Grid>

              {createBookingResponse.basket.transfers[1] && (
                <Grid item xs={12} md={12}>
                  <Typography variant="subtitle1" style={{
                    textAlign: 'left',
                    font: '12px arial,serif',
                    fontFamily: 'Nexa,sans-serif',
                    color: '#444',
                  }}>
                    <span style={{ fontWeight: 'bold' }}>Inbound:</span> {travelDetails.dropoffValue.label} To {travelDetails.pickupValue.label} On  The {dayjs(travelDetails.returnDate).format('D MMM, YYYY')} At
                    <span> {travelDetails.returnTime} For  </span>{travelDetails.adultsCount > 0 || travelDetails.childrenCount.length > 0 || travelDetails.infantsCount > 0 ? (
                      <span>
                        {travelDetails.adultsCount} Adults
                        {travelDetails.childrenCount.length > 0 &&
                            `, ${travelDetails.childrenCount.length} ${travelDetails.childrenCount.length > 1 ? 'Children' : 'Child'}`}
                        {`, Hold Luggage ${holdLuggage}`}
                      </span>
                    ) : null}
                  </Typography>
                </Grid>
              )}

            </Grid>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 10px 10px 0' }}>
              {/* Padding added for spacing from the right and bottom edges */}
              <Button
                color="primary"
                variant="outlined"
                size="small"
                onClick={() => {
                  window.location.href = apiFrontendURL;
                }}
                style={{
                  textTransform: 'none',
                  borderColor: 'black',
                  padding: '4px 10px',
                  fontWeight: '500',
                  fontSize: '12px',
                  marginLeft: 'auto', // This will push the button to the right
                }}
              >
                Change
              </Button>

            </Grid>

          </CardContent>
        </Card>

        <Grid container spacing={2} className={`${classes.root} ${classes.spacing}`}>
          {/* Progress Bar */}
          <Grid
            item
            xs={12}
            md={12}
            style={{
              display: 'flex',
              justifyContent: 'center', // Right align for medium screens, center for small screens
              alignItems: 'center',
              padding: '10px',
            }}
          >
            <Grid xs={12} md={9}>
              <ProgressBar currentStep={1} />
            </Grid>
          </Grid>
          {/* Heading and Progress Bar Section */}
          <Grid
            container
            item
            xs={12}
            md={12}
            style={{
              display: 'flex',
              flexWrap: 'wrap', // Wraps items on smaller screens
              justifyContent: 'center', // Centered alignment for smaller screens
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            {/* Heading */}
            <Grid
              item
              xs={12}
              md={12}
              style={{
                display: 'flex',
                justifyContent: 'center', // Center heading
                alignItems: 'center',
                padding: '10px',
              }}
            >
              <Typography
                variant="h2"
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '700',
                  color: '#333',
                  fontFamily: 'Nexa, sans-serif',
                  lineHeight: '1.6',
                }}
              >
                Choose Your Transfer
              </Typography>
            </Grid>


          </Grid>


          {/* Subtext and Dropdown Section */}
          <Grid
            container
            item
            xs={12}
            style={{
              display: 'flex',
              flexWrap: 'wrap', // Allow wrapping
              justifyContent: 'flex-end', // Center items
              alignItems: 'center',
              padding: '12px 16px',
              marginRight: '-10px'
            }}
          >
            {/* Dropdown */}
            <Select
              sx={{
                width: '120px',
                height: '40px',
                backgroundColor: '#add8e6',
                color: '#000080',
                '& .MuiSelect-icon': {
                  color: '#000080',
                },
                marginLeft: '8px',
              }}
              value={selectedCurrency}
              variant="outlined"
              onChange={handleCurrencyChange}
            >
              {Object.keys(quoteResponse.basket.availableCurrencies).map((currency) => (
                <MenuItem key={currency} value={currency}>
                  {currency}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>

        {/*Promo code input*/}
        {promoCodeInputDisplay && (
          <Grid item xs={12} md={12} marginBottom={'10px'}>
            <PromoCodeInput />
          </Grid>
        )}

        {/* New Products Sorted */}
        {sortedCombinedArray.map((response, index) => {

          let passengers = travelDetails.adultsCount + travelDetails.childrenCount.length;
          let price = `${currencySymbols[selectedCurrency] || "£"}${(response.totalCost / 100).toFixed(2)}`;
          let perPerson = `${currencySymbols[selectedCurrency] || "£"}${(response.costPerPerson / 100).toFixed(2)}`;

          return (

            response.isCombination ? (
              // Combination Card

                <Card sx={{ borderRadius: 3, boxShadow: 2, mb: 2 }}>
                  <CardContent sx={{ p: 0 }}>
                    <Grid container>

                      {/* LEFT: OUTBOUND + INBOUND */}
                      <Grid item xs={12} md={5.5} sx={{ p: 3 }} alignItems={'center'}>
                        <Stack
                            direction={{ xs: "column", md: "row" }}
                            alignItems="center"
                            justifyContent="center"
                            spacing={2}
                        >
                          {/* OUTBOUND */}
                          <Stack alignItems="center" spacing={1}>
                            {getIcon2(response.outbound.transferTypeCode)}
                            <Typography fontWeight={700} color="#265886">
                              OUTBOUND
                            </Typography>
                            <Typography color={'#265886'} variant={"h6"} fontSize={'25px'} fontFamily={'Nexa,sans-serif'} fontWeight={700}>
                              {getTransferType(response.outbound.transferTypeCode)}
                            </Typography>

                            <Stack spacing={1.5} mt={2} flexWrap={'wrap'} alignItems={"center"}>
                              <Stack direction="row" spacing={2}>
                                <Stack direction="row" spacing={0.5} alignItems="center">
                                  <PersonIcon
                                      alt="Person Icon"
                                      width="29"
                                      height="29"
                                      style={{color: '#265886' }}
                                  />

                                  <Typography variant="body2" fontSize={'16px'} color={'#265886'}>{passengers} passengers</Typography>
                                </Stack>
                                <Stack direction="row" spacing={0.5} alignItems="center">
                                  <WorkIcon
                                      alt="Person Icon"
                                      width="29"
                                      height="29"
                                      style={{ color: '#265886' }}
                                  />
                                  <Typography variant="body2" fontSize={'16px'} color={'#265886'}>{passengers} luggage</Typography>
                                </Stack>
                              </Stack>

                              <Stack
                                  direction="row"
                                  spacing={0.5}
                                  alignItems="center"
                                  sx={{
                                    cursor: "pointer",
                                    alignSelf: "flex-start",
                                  }}
                                  onClick={() => toggleMoreInfo1(index)}
                              >
                                {isMoreInfoOpenArray1[index] ? <CloseIcon fontSize="extra-small" sx={{ color: '#265886' }}/> : <InfoIcon fontSize="extra-small" sx={{ color: '#265886' }} />}
                                <Typography variant="body"  fontSize={'16px'} color={'#265886'}>Product Info...</Typography>
                              </Stack>

                              <Collapse in={isMoreInfoOpenArray1[index]}>
                                <Box
                                    sx={{
                                      bgcolor: "#f5f5f5",
                                      p: 2,
                                      borderRadius: 2,
                                      mt: 1,
                                    }}
                                >
                                  {response.outbound.description?.slice(0, 4).map((d, i) => (
                                        <Typography key={i} component="span" fontSize={'16px'} sx={{ display: 'block', whiteSpace: 'pre-line' }}>
                                          • {stripHtmlTags(d)}
                                        </Typography>
                                  ))}
                                  <Typography key={10} variant="span" fontSize={'16px'}>
                                    • Vehicles displayed on our website, are representative of the category selected and are shown for illustrative purposes only. The actual vehicle provided may differ from that shown on the website.
                                  </Typography>
                                </Box>
                              </Collapse>
                            </Stack>
                          </Stack>

                          {/* DIVIDER */}
                          <Typography
                              sx={{
                                fontSize: 40,
                                fontWeight: 300,
                                color: "#265886",
                              }}
                          >
                            /
                          </Typography>

                          {/* INBOUND */}
                          <Stack alignItems="center" spacing={1}>
                            {getIcon2(response.inbound.transferTypeCode)}
                            <Typography fontWeight={700} color="#265886">
                              INBOUND
                            </Typography>
                            <Typography color={'#265886'} variant={"h6"} fontSize={'25px'} fontFamily={'Nexa,sans-serif'} fontWeight={800}>
                              {getTransferType(response.inbound.transferTypeCode)}
                            </Typography>

                            <Stack spacing={1.5} mt={2} flexWrap={'wrap'} alignItems={"center"}>
                              <Stack direction="row" spacing={2}>
                                <Stack direction="row" spacing={0.5} alignItems="center">
                                  <PersonIcon
                                      alt="Person Icon"
                                      width="29"
                                      height="29"
                                      style={{color: '#265886' }}
                                  />

                                  <Typography variant="body2" color={'#265886'}>{passengers} passengers</Typography>
                                </Stack>
                                <Stack direction="row" spacing={0.5} alignItems="center">
                                  <WorkIcon
                                      alt="Person Icon"
                                      width="29"
                                      height="29"
                                      style={{ color: '#265886' }}
                                  />
                                  <Typography variant="body2" fontSize={'16px'} color={'#265886'}>{passengers} luggage</Typography>
                                </Stack>
                              </Stack>

                              <Stack
                                  direction="row"
                                  spacing={0.5}
                                  alignItems="center"
                                  sx={{
                                    cursor: "pointer",
                                    alignSelf: "flex-start",
                                  }}
                                  onClick={() => toggleMoreInfo1(index)}
                              >
                                {isMoreInfoOpenArray1[index] ? <CloseIcon fontSize="extra-small" sx={{ color: '#265886' }}/> : <InfoIcon fontSize="extra-small" sx={{ color: '#265886' }} />}
                                <Typography variant="body"  fontSize={'16px'} color={'#265886'}>Product Info...</Typography>
                              </Stack>

                              <Collapse in={isMoreInfoOpenArray1[index]}>
                                <Box
                                    sx={{
                                      bgcolor: "#f5f5f5",
                                      p: 2,
                                      borderRadius: 2,
                                      mt: 1,
                                    }}
                                >
                                  {response.inbound.description?.slice(0, 4).map((d, i) => (
                                      <Typography key={i} component="div" fontSize={'16px'} sx={{ display: 'block', whiteSpace: 'pre-line' }}>
                                        • {stripHtmlTags(d)}
                                      </Typography>
                                  ))}
                                  <Typography key={5} variant="div" fontSize={'16px'} sx={{ display: 'block', whiteSpace: 'pre-line' }}>
                                    • Vehicles displayed on our website, are representative of the category selected and are shown for illustrative purposes only. The actual vehicle provided may differ from that shown on the website.
                                  </Typography>
                                </Box>
                              </Collapse>
                            </Stack>
                          </Stack>
                        </Stack>
                      </Grid>

                      {/* MIDDLE: MESSAGE */}
                      <Grid
                          item
                          xs={12}
                          md={2.5}
                          sx={{
                            borderLeft: { md: "1px solid #eee" },
                            borderTop: { xs: "1px solid #eee", md: "none" },
                            p: 3,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: "center",
                          }}
                      >
                        <Stack spacing={1}>
                          <Typography color="#265886" fontWeight={500}>
                            A different type of transfer for each journey
                          </Typography>

                          <Typography fontWeight={700} color="#265886">
                            Available to book now
                          </Typography>
                          <Stack direction="row" alignItems="center" flexWrap="wrap" justifyItems={'center'}  justifyContent={"center"} sx={{ width: '100%', gap:1 }}>
                            <Chip size="small" sx={{backgroundColor:'#b6dafa', color: '#265886', '& .MuiChip-label': {fontSize: '0.75rem' }}} label="24/7 Support"/>
                          </Stack>
                        </Stack>
                      </Grid>

                      {/* RIGHT: PRICE */}
                      <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            borderLeft: { md: "1px solid #eee" },
                            borderTop: { xs: "1px solid #eee", md: "none" },
                            p: 3,
                          }}
                      >
                        <Stack spacing={1.5} alignItems={{ xs: "center", md: "flex-start" }}>

                          {/* Discount */}
                          {quoteResponse?.basket?.promoOffer && (
                              <Stack direction="row" spacing={1} alignItems="center">
                                <Typography
                                    sx={{ textDecoration: "line-through", color: "gray" }}
                                >
                                  {currencySymbols[selectedCurrency]}
                                  {(
                                      response.totalCost /
                                      (1 - quoteResponse.basket.promoOffer.value / 100) /
                                      100
                                  ).toFixed(2)}
                                </Typography>

                                <Chip
                                    label={`${quoteResponse.basket.promoOffer.value}% OFF`}
                                    size="small"
                                    sx={{ bgcolor: "green", color: "#fff", fontWeight: 700 }}
                                />
                              </Stack>
                          )}

                          {/* Price */}
                          <Typography
                              sx={{
                                fontSize: 44,
                                fontWeight: 700,
                                color: "#265886",
                              }}
                          >
                            £{(response.totalCost / 100).toFixed(2)}
                          </Typography>

                          { quoteResponse.basket.promoOffer && (
                              <Box sx={{ display: "flex", alignItems:'center', justifyContent: { xs: "center", md: "flex-start" }, gap: 1 }}>
                                <Typography
                                    variant="body"
                                    sx={{ color: "green", fontWeight: "800" }}
                                >
                                  Save {currencySymbols[selectedCurrency]} {((response.totalCost / (1 - (quoteResponse.basket.promoOffer.value / 100)) / 100) - ((response.totalCost * (quoteResponse.basket.promoOffer.value / 100)) / 10)).toFixed(2)}

                                </Typography>
                              </Box>
                          )
                          }
                          <Typography variant="body2" color="text.secondary">
                            £{(response.costPerPerson / 100).toFixed(2)} per person
                          </Typography>

                          {/* CTA */}
                          {response.transferTypeCode === "SCHD" && schdMessage && (
                              // Display a specific message for SCHD option when schdMessage is true
                              <Typography variant="body2" style={{ color: 'grey', marginTop: '10px', fontWeight: 'bold' }}>
                                None of the scheduled bus times are suitable for one of your flight times
                              </Typography>
                          )}

                          {response.transferTypeCode !== "SCHD" ? (
                          <Button
                              variant="contained"
                              sx={{
                                bgcolor: "rgb(17,137,17)",
                                px: 4,
                                py: 1.3,
                                fontSize:'18px',
                                fontWeight: "bold",
                                borderRadius: 2,
                                minWidth: 220,
                              }}
                              onClick={() => {
                                let totalCost, costPerPerson;

                                totalCost = response.totalCost;
                                costPerPerson = response.costPerPerson

                                handleBookNow(index, totalCost, costPerPerson, response.outbound.transferTypeCode, response.description, selectedCurrency, response.inbound.transferTypeCode);
                              }}
                          >
                            {response.book ? "Book Now" : "Enquire"}
                            {response.book && quoteResponse?.basket.promoOffer && (
                                ` - SAVE ${quoteResponse.basket.promoOffer.value}%`
                            )}
                          </Button>) : ('')}

                          {/* Benefits */}
                          <Stack spacing={0.5}>
                            <Typography variant="body2" sx={{ color: '#265886' }}>
                              <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                              Instant Confirmation
                            </Typography>
                          </Stack>
                          <Stack spacing={0.5}>
                            <Typography variant="body2" sx={{ color: '#265886' }}>
                              <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                              Free cancellation, 7 days before
                            </Typography>
                          </Stack>
                          <Stack spacing={0.5}>
                            <Typography variant="body2" sx={{ color: '#265886' }}>
                              <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                              No admin fees
                            </Typography>
                          </Stack>

                          {/* Trustpilot */}
                          <Box mt={1.5}>
                            <Stack direction="row" spacing={0.5} justifyContent={{xs: 'center', md: 'left'}}
                                   alignItems={{xs: 'center', md: 'left'}}>
                            <img
                                src={TrustpilotImage}
                                alt="Trustpilot Rating"
                                style={{
                                  width: window.innerWidth <= 600 ? '100px' : '120px',
                                  height: 'auto',
                                  marginLeft: window.innerWidth <= 600 ? '10px' : '0px',
                                  // marginTop: '100px'
                                }}
                            />
                            </Stack>
                          </Box>
                        </Stack>
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>

            ) : (
                <Card key={index} sx={{borderRadius: 3, boxShadow: 2, mb: 1}}>
                  <CardContent sx={{p: 0}}>
                    <Grid container alignItems={'center'}>

                      {/* LEFT */}
                      <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{backGroundColor:'white', p: 3, textAlign: { xs: "center", md: "left" } }}
                      >

                        {getIcon(response.transferTypeCode)}


                        <Stack spacing={1.5} mt={2} flexWrap={'wrap'} alignItems={"center"}>
                          <Stack direction="row" spacing={2}>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                              <PersonIcon
                                  alt="Person Icon"
                                  width="29"
                                  height="29"
                                  style={{color: '#265886' }}
                              />

                              <Typography variant="body2" fontSize={'16px'} color={'#265886'}>{passengers} passengers</Typography>
                            </Stack>
                            <Stack direction="row" spacing={0.5} alignItems="center">
                              <WorkIcon
                                  alt="Person Icon"
                                  width="29"
                                  height="29"
                                  style={{ color: '#265886' }}
                              />
                              <Typography variant="body2" fontSize={'16px'} color={'#265886'}>{passengers} luggage</Typography>
                            </Stack>
                          </Stack>

                          <Stack
                              direction="row"
                              spacing={0.5}
                              alignItems="center"
                              sx={{
                                cursor: "pointer",
                                alignSelf: "flex-start",
                              }}
                              onClick={() => toggleMoreInfo1(index)}
                          >
                            {isMoreInfoOpenArray1[index] ? <CloseIcon fontSize="extra-small" sx={{ color: '#265886' }}/> : <InfoIcon fontSize="extra-small" sx={{ color: '#265886' }} />}
                            <Typography variant="body" fontSize={'16px'} color={'#265886'}>Product Info...</Typography>
                          </Stack>

                          <Collapse in={isMoreInfoOpenArray1[index]}>
                            <Box
                                sx={{
                                  bgcolor: "#f5f5f5",
                                  p: 2,
                                  borderRadius: 2,
                                  mt: 1,
                                }}
                            >
                              {response.description?.slice(0, 4).map((d, i) => (
                                  <Typography key={i} component="div" fontSize={'16px'} sx={{ display: 'block', whiteSpace: 'pre-line' }}>
                                    • {stripHtmlTags(d)}
                                  </Typography>
                              ))}
                              <Typography key={5} variant="div" fontSize={'16px'} sx={{ display: 'block', whiteSpace: 'pre-line' }}>
                                • Vehicles displayed on our website, are representative of the category selected and are shown for illustrative purposes only. The actual vehicle provided may differ from that shown on the website.
                              </Typography>
                            </Box>
                          </Collapse>
                        </Stack>
                      </Grid>

                      {/* MIDDLE */}
                      <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            p: 3,
                            borderLeft: { md: "1px solid #eee" },
                            borderTop: { xs: "1px solid #eee", md: "none" },
                            textAlign: "center",
                            display: 'flex',
                            flexDirection: 'column', // To stack content vertically on small screens
                            justifyContent: 'center',
                            alignItems: 'center'
                          }}
                      >

                        <Typography color={'#265886'} variant={"h2"} fontSize={'41px'} fontFamily={'Nexa,sans-serif'} fontWeight={800}>
                          {getTransferType(response.transferTypeCode)}
                        </Typography>

                        {getTransferTypeUSPMain(response.transferTypeCode) !== null && (
                            <Tooltip
                                title={stripHtmlTags(response.description[0])}
                                arrow
                                placement="bottom"
                            >
                            <Typography fontSize={'17px'} color={'#265886'} mb={2} sx={{ cursor: 'help', display: 'inline-block' }}>
                              {getTransferTypeUSPMain(response.transferTypeCode)}
                            </Typography>
                            </Tooltip>
                        )}

                        <Stack direction="row" alignItems="center" flexWrap="wrap" justifyItems={'center'}  justifyContent={"center"} sx={{ width: '100%', gap:1 }}>
                          {getTransferUSPs(response.transferTypeCode).map((usp, index) => (
                              <Chip
                                  key={index}
                                  size="medium"
                                  label={usp}
                                  sx={{
                                    backgroundColor: '#b6dafa',
                                    color: '#265886',
                                    '& .MuiChip-label': {
                                      fontSize: '0.8rem',
                                    },
                                  }}
                              />
                          ))}

                        </Stack>
                      </Grid>

                      {/* RIGHT */}
                      <Grid
                          item
                          xs={12}
                          md={4}
                          sx={{
                            p: 3,
                            borderLeft: { md: "1px solid #eee" },
                            borderTop: { xs: "1px solid #eee", md: "none" },
                            textAlign: { xs: 'center', md: 'left' },
                            display: 'flex',
                            flexDirection: 'column', // To stack content vertically on small screens
                            justifyContent: 'center',
                            alignItems: 'left'
                          }}
                      >
                        { quoteResponse.basket.promoOffer && (
                          <Box sx={{ display: "flex", alignItems:'center', justifyContent: { xs: "center", md: "flex-start" }, gap: 1 }}>
                              <Typography
                                  variant="body1"
                                  fontSize={'17px'}
                                  fontFamily={'"Nexa","Arial",sans-serif!important'}
                                  sx={{ textDecoration: "line-through", color: "gray" }}
                              >
                                {currencySymbols[selectedCurrency]} {(response.totalCost / (1 - (quoteResponse.basket.promoOffer.value / 100)) / 100).toFixed(2)}
                              </Typography>
                              <Chip
                                  label={`${quoteResponse.basket.promoOffer.value}% OFF`}
                                  size="medium"
                                  fontFamily={'"Nexa","Arial",sans-serif!important'}
                                  sx={{ bgcolor: "green", color: "#fff", fontWeight: "bold" }}
                              />
                          </Box>
                        )
                        }
                        <Typography color={'#265886'} fontSize={'50px'} fontFamily={'"Nexa","Arial",sans-serif!important'} fontWeight={700}>
                          {response.book === true ? price : "Limited Availability"}
                        </Typography>

                        { quoteResponse.basket.promoOffer && (
                            <Box sx={{ display: "flex", alignItems:'center', justifyContent: { xs: "center", md: "flex-start" }, gap: 1 }}>
                              <Typography
                                  variant="body"
                                  fontSize={'19px'}
                                  fontFamily={'"Nexa","Arial",sans-serif!important'}
                                  sx={{ color: "green", fontWeight: "800" }}
                              >
                                Save {currencySymbols[selectedCurrency]} {((response.totalCost / (1 - (quoteResponse.basket.promoOffer.value / 100)) / 100) - ((response.totalCost * (quoteResponse.basket.promoOffer.value / 100)) / 10)).toFixed(2)}

                              </Typography>
                            </Box>
                        )
                        }

                        <Typography variant="body1" color="text.secondary" mb={2}>
                          {response.book ? `${perPerson} per person` : `Prices from ${price}`}
                        </Typography>

                        {loading && loadingIndex === index ? (
                            <Stack direction="row" spacing={1} justifyContent="center">
                              <CircularProgress size={20} />
                              <Typography>{loadingText}</Typography>
                            </Stack>
                        ) : (
                            <Grid>
                            <Button
                                variant="contained"
                                sx={{
                                  backgroundColor: response.book ? "rgb(17, 137, 17)" : "#f0ad4e",
                                  px: 5.6,
                                  py: 1.3,
                                  borderRadius: 2,
                                  fontSize:'18px',
                                  fontWeight: 'bold',
                                  letterSpacing: '0.02857em',
                                  lineHeight: '1.75',
                                  fontFamily: '"Nexa","Arial",sans-serif!important',
                                  minWidth: {xs:240,md:200}
                                }}
                                onClick={() => {
                                  handleBookNow(
                                      index,
                                      response.totalCost,
                                      response.totalCost / 2,
                                      response.transferTypeCode,
                                      response.description,
                                      selectedCurrency
                                  );
                                  dispatch(setCombinations([]));
                                }}
                            >
                              {response.book ? "Book Now" : "Enquire"}
                              {response.book && quoteResponse?.basket.promoOffer && (
                                  ` - SAVE ${quoteResponse.basket.promoOffer.value}%`
                              )}
                            </Button>
                            </Grid>
                        )}

                        <Grid mt={2}>
                            <Stack spacing={1} alignItems={{ xs: 'center', md: 'flex-start' }}>
                              <Typography variant="body2" sx={{ color: '#265886' }}>
                                <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                                Instant Confirmation
                              </Typography>
                            </Stack>
                            <Stack spacing={0.5}>
                              <Typography variant="body2" sx={{ color: '#265886' }}>
                                <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                                Free cancellation, 7 days before
                              </Typography>
                            </Stack>
                            <Stack spacing={0.5}>
                              <Typography variant="body2" sx={{ color: '#265886' }}>
                                <span style={{ color: 'rgb(17, 137, 17)', marginRight: 4 }}>✔</span>
                                No admin fees
                              </Typography>
                            </Stack>
                          <Box mt={1.5}>
                            <Stack direction="row" spacing={0.5} justifyContent={{xs: 'center', md: 'left'}}
                                   alignItems={{xs: 'center', md: 'left'}}>
                              <img
                                  src={TrustpilotImage}
                                  alt="Trustpilot Rating"
                                  style={{
                                    width: window.innerWidth <= 600 ? '90px' : '110px',
                                    height: 'auto',
                                    marginLeft: window.innerWidth <= 600 ? '10px' : '0px',
                                   // marginTop: '100px'
                                  }}
                              />
                            </Stack>
                          </Box>

                        </Grid>
                      </Grid>

                    </Grid>
                  </CardContent>
                </Card>
            )
          );
        })}


      </div>

    </div>
  );
};

export default withStyles(styles, {withTheme: true})(QuoteProducts);

